const Contact = () => {
  return (
    <>
      <div className="page-header">
        <h1>Contact Us</h1>
      </div>
      <div className="page-content">
        You can mail me at: ravi9793@gmail.com<br />
        Please do not spam me.
      </div>
    </>
  )
}
export default Contact;